import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, TextField, Button, Dialog, DialogTitle, DialogContent, DialogActions, Avatar, Menu, MenuItem } from '@mui/material';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';
import axios from 'axios';
import { useLocation, useHistory } from "react-router-dom";

function AcademicSubjectsPage() {
    const history = useHistory();

    // extract topicName from url (e.g. /topics/science → topicName = "science")
    const { academicTopic } = useParams();

    // state to hold list of posts under this topic
    const [posts, setPosts] = useState([]);

    // state to track content of new post being typed
    const [newPost, setNewPost] = useState('');

    // title of post
    const [title, setTitle] = useState('');

    // post dialogue box
    const [open, setOpen] = useState(false);

    // state to track which subtopic button was clicked (Majors or Clubs)
    // null => no search bar is shown. Clubs => show Clubs search bar
    const [activeSearch, setActiveSearch] = useState(null);

    // state to store user's input in search bar
    const [searchInput, setSearchInput] = useState('');

    const [loggedInUser, setLoggedInUser] = useState(null);

    const [cursor, setCursor] = useState(null);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    useEffect(() => {
        axios.get("/user/me")
            .then(res => setLoggedInUser(res.data))
            .catch(() => setLoggedInUser(null));
    }, []);

    /*
    // run once on mount or when topicName changes
    useEffect(() => {
        // GET request to backend to load all posts in current topic
        axios.get(`/topics/${academicTopic}/posts`)
            // store returned post in state
            .then(res => setPosts(res.data))
            // log errors
            .catch(err => console.error(err));
    }, [academicTopic]); // rerun if topicName changes
    */

    let topicType = "academicSubject";
    // called when user submits new post
    /*const handlePost = async () => {
        // prevent empty submissions
        if (!newPost.trim()) return;

        // POST request to create new post in topic
        //const res = await axios.post(`/topics/${academicTopic}/posts`, { title, content: newPost });
        await axios.post(`/topics/${academicTopic}/posts`, { 
            title, 
            content: newPost,
            topicType
         });

        // add new post to top of list
        //setPosts(prev => [res.data, ...prev]);

        // clear input field
        setNewPost('');
        setOpen(false);
        setTitle('');
        //alert('Post created!');

        // Refetch posts to get populated author info
        axios.get(`/topics/${academicTopic}/posts`)
            .then(res => setPosts(res.data))
            .catch(err => console.error(err));
    };*/
    const handlePost = async () => {
        if (!newPost.trim()) return;

        try {
            const res = await axios.post(`/topics/${academicTopic}/posts`, {
                title,
                content: newPost,
                topicType
            });

            const newCreatedPost = res.data; // assuming backend returns the created post

            setPosts(prev => [newCreatedPost, ...prev]); // prepend
            setCursor(null);     // force reload chain
            setHasMore(true);

            setNewPost('');
            setOpen(false);
            setTitle('');

        } catch (err) {
            console.error(err);
        }
    };

    const toggleVote = async (postId) => {
        try {
            const res = await axios.post(`/post/${postId}/upvote`);
            setPosts(prev =>
                prev.map(p =>
                    p._id === postId
                    ? { ...p, upvotes: res.data.upvotes, voted: res.data.voted }
                    : p
                )
            );
        } catch (err) {
            console.error("Vote error", err);
        }
    };

    const handleAddComment = async (postId, commentText) => {
        if (!commentText.trim()) return;

        try {
            const res = await axios.post(`/post/${postId}/comment`, { text: commentText });
            setPosts(prev =>
            prev.map(p =>
                p._id === postId
                ? { ...p, comments: res.data, newComment: "" }
                : p
            )
            );
        } catch (err) {
            console.error("Failed to add comment", err);
        }
    };

    const joinVideoCall = async (postId) => {
        try {
            const res = await axios.post(`/post/${postId}/video-room`);
            const roomUrl = res.data.url;
            window.open(roomUrl, "_blank");
        } catch (err) {
            console.error("Failed to join video call", err);
            alert("Could not join video call.");
        }
    };

    // fxn that handles navigation when user hits go
    //const handleNavigate = (basePath) => {
    const handleNavigate = (mainTopic, subTopicType) => {
        // only proceed if user entered something
        if (searchInput.trim()) {
            // navigate to dynamic route like /topics/Major/<majorName> OR /topics/Clubs/<clubName>
            //history.push(`/topics/${basePath}/${encodeURIComponent(searchInput.trim())}`);
            history.push(`/topics/${encodeURIComponent(mainTopic)}/${subTopicType}/${encodeURIComponent(searchInput.trim())}`);

            // clear search input after navigation
            setSearchInput('');

            // hide search bar by resetting activeSearch
            setActiveSearch(null);
        }
    };

    const [sortBy, setSortBy] = useState("recent"); 
    const defaultLabel = `Recent ${academicTopic}`;
    const [menuLabel, setMenuLabel] = useState(defaultLabel);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    /*const handleMenuClose = (selectedLabel, sortType) => {
        setAnchorEl(null);
        if (selectedLabel) setMenuLabel(selectedLabel);
        if (sortType) setSortBy(sortType);
   };*/
   const handleMenuClose = (selectedLabel, sortType) => {
        setAnchorEl(null);
        if (selectedLabel) setMenuLabel(selectedLabel);
        if (sortType) {
            setSortBy(sortType);
            setPosts([]);       // clear previous posts
            setCursor(null);    // reset cursor
            setHasMore(true);   // allow fetching first page
        }
    };

   /*useEffect(() => {
        axios
            .get(`/topics/${academicTopic}/posts?sort=${sortBy}`)
            .then((res) => setPosts(res.data))
            .catch((err) => console.error(err));
    }, [academicTopic, sortBy]);*/
    /*useEffect(() => {
        setPosts([]);
        setCursor(null);
        setHasMore(true);
    }, [academicTopic, sortBy]);*/

    /*const fetchPosts = async () => {
        if (loading || !hasMore) return;

        try {
            setLoading(true);

            const res = await axios.get(`/topics/${academicTopic}/posts`, {
                params: {
                    cursor,
                    limit: 10,
                    sort: sortBy
                }
            });

            const newPosts = Array.isArray(res.data.posts) ? res.data.posts : [];

            setPosts(prev => [...prev, ...newPosts]);
            setCursor(res.data.nextCursor);
            setHasMore(res.data.hasMore);

        } catch (err) {
            console.error("Error loading posts", err);
        } finally {
            setLoading(false);
        }
    };*/
    const fetchPosts = async (overrideCursor = cursor) => {
        if (loading || !hasMore) return;

        try {
            setLoading(true);

            const res = await axios.get(`/topics/${academicTopic}/posts`, {
                params: {
                    cursor: overrideCursor,
                    limit: 10,
                    sort: sortBy
                }
            });

            const newPosts = Array.isArray(res.data.posts) ? res.data.posts : [];

            setPosts(prev => {
                // prevent duplicates (IMPORTANT for race conditions)
                const ids = new Set(prev.map(p => p._id));
                const filtered = newPosts.filter(p => !ids.has(p._id));
                return [...prev, ...filtered];
            });

            setCursor(res.data.nextCursor);
            setHasMore(res.data.hasMore);

        } catch (err) {
            console.error("Error loading posts", err);
        } finally {
            setLoading(false);
        }
    };

    // RESET when topic/sort changes
    useEffect(() => {
        setPosts([]);
        setCursor(null);
        setHasMore(true);
    }, [academicTopic, sortBy]);

    // FETCH when cursor changes (or initial load)
    useEffect(() => {
        fetchPosts();
    }, [cursor, academicTopic, sortBy]);

    useEffect(() => {
        if (cursor === null && hasMore) {
            fetchPosts(null); // explicitly pass null
        }
    }, [cursor, hasMore, academicTopic, sortBy]);

    const observer = useRef();

    /*const lastPostRef = useCallback(node => {
        if (loading) return;

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                fetchPosts();
            }
        });

        if (node) observer.current.observe(node);

    }, [loading, hasMore]);*/
    const lastPostRef = useCallback(node => {
        if (loading) return;

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                fetchPosts(); // now safe
            }
        });

        if (node) observer.current.observe(node);
    }, [loading, hasMore, fetchPosts]); 

    const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

    const isJoined = loggedInUser?.joinedAcademicSubjects?.includes(academicTopic);

    const toggleJoinAcademicSubject = async () => {
        if (!loggedInUser) return;

        if (isJoined) {
            await axios.post(`/academicSubject/${academicTopic}/leave`);
            setLoggedInUser(prev => ({
                ...prev,
                joinedAcademicSubjects: prev.joinedAcademicSubjects.filter(t => t !== academicTopic)
            }));
        } else {
            await axios.post(`/academicSubject/${academicTopic}/join`);
            setLoggedInUser(prev => ({
                ...prev,
                joinedAcademicSubjects: [...prev.joinedAcademicSubjects, academicTopic]
            }));
        }
    };

    useEffect(() => {
        posts.forEach(post => {
            console.log(post.topicType);
        });
    }, [posts]);


    const location = useLocation();
    const navItems = [
      { label: "Popular Academia", path: "/mainsocial/academia/popular" },
      //{ label: "University", path: "/topics" },
      {
            label: "University",
            path: "/mainsocial/academia/university"
        },
      { label: "Academic Subjects", path: "/mainsocial/academia/academicsubjects", matchPaths: ["/academicSubjects", "/mainsocial/academia/academicsubjects"] },
    ];

    const getButtonStyles = (item) => {
      //const active = location.pathname.startsWith(path);
      const active = item.matchPaths
        ? item.matchPaths.some(path => location.pathname.startsWith(path))
        : location.pathname.startsWith(item.path);

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };
    return (
        <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >
        {/* Sticky Navigation */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      //sx={getButtonStyles(item.path)}
                      sx={getButtonStyles(item)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
              </Box>
            <Box 
                display="flex" 
                justifyContent="center" 
                mt={2} 
                mb={2}
            >
                <Typography variant="h4">c/{academicTopic}</Typography>
            </Box>

            <Box display="flex" justifyContent="center" gap={2} mb={3}>
                <Button variant="outlined" onClick={handleMenuOpen}>
                    {menuLabel}
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => handleMenuClose(null)}
                    >
                    {/* Popular option */}
                    {/*<MenuItem
                        onClick={() =>
                        handleMenuClose(defaultLabel, "popular")
                        }
                    >
                        {defaultLabel}
                    </MenuItem>*/}
                    <MenuItem
                        onClick={() =>
                            handleMenuClose(`Popular ${academicTopic}`, "popular")
                        }
                    >
                        Popular {academicTopic}
                    </MenuItem>

                    {/* Recent option */}
                    {/*<MenuItem
                        onClick={() =>
                        handleMenuClose("Recent", "recent")
                        }
                    >
                        Recent
                    </MenuItem>*/}
                    <MenuItem
                        onClick={() =>
                            handleMenuClose(`Recent ${academicTopic}`, "recent")
                        }
                    >
                        Recent {academicTopic}
                    </MenuItem>
                    <MenuItem
                        onClick={() =>
                        handleMenuClose("Cracked", "Cracked")
                        }
                    >
                        Cracked
                    </MenuItem>
                </Menu>
                {/*<Button 
                    variant="outlined" 
                    onClick={() => setOpen(true)}
                >
                    Post
                </Button>*/}
                <Button
                    variant={isJoined ? "contained" : "outlined"}
                    onClick={toggleJoinAcademicSubject}
                >
                    {isJoined ? "Joined" : "Join"}
                </Button>
            </Box>
            {/** topic name title */}
            {/*<Typography variant="h4">/topic/{academicTopic}</Typography>*/}

            {/** show search bar when button is clicked */}
            {activeSearch && (
                // conditional rendering: only show this section if activeSearch is not null
                <Box mt={3}>
                    {/* Dynamic text: "Search Majors" or "Search Clubs" */}
                    <Typography variant="h6">
                        Search {activeSearch}
                    </Typography>

                    <Box display="flex" gap={2} mt={1}>
                        <TextField
                            // placeholder changes based on which button was clicked
                            placeholder={`Search ${activeSearch}`}
                            // controlled input bound to searchInput state
                            value={searchInput}
                            // update user state as user types
                            onChange={(e) => setSearchInput(e.target.value)}
                        />
                        {/* Clicking "Go" navigates to the correct subtopic page */}
                         <Button
                            variant="contained"
                            onClick={() => handleNavigate(academicTopic, activeSearch)}
                         >
                            Go
                         </Button>
                         <Button
                            variant="outlined"
                            onClick={() => setActiveSearch(null)}
                         >
                            Cancel
                         </Button>
                    </Box>
                </Box>
            )}

            {/** new post input box */}
            {/*
            <Box my={2}>
                <TextField
                    fullWidth // take full width of container
                    value={newPost} // controlled input value
                    onChange={(e) => setNewPost(e.target.value)} // update new post as user types
                    placeholder="Write a post..." // placeholder before user types
                />
                <Button
                    sx={{ mt: 1 }}  // margin top
                    variant="contained" // filled button style
                    onClick={handlePost} // call handler on click
                >
                    Submit
                </Button>
            </Box>
            */}

            {/* Create Post Button */}
            {/*
            <Button variant="contained" onClick={() => setOpen(true)}>
                Post
            </Button>*/}

            {/* Dialog for Creating Post */}
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Make a post on the {academicTopic} page</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Post Title"
                        fullWidth
                        placeholder="Title of your post"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                    <TextField
                        margin="dense"
                        label="Post Content"
                        fullWidth
                        placeholder="Write"
                        multiline
                        minRows={4}
                        value={newPost}
                        onChange={(e) => setNewPost(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button onClick={handlePost} variant="contained">Submit</Button>
                </DialogActions>
            </Dialog>   

            <Box
                  p={2} // padding inside box
                  my={2} // vertical margin between posts
                  border="1px solid #ccc" // light grey border
                  borderRadius="8px" // rounded corners
                  sx={{
                      position: "relative",
                      maxWidth: 900, // limit width
                      mx: "auto", // center horizontally
                      my: 2, // vertical spacing between each post
                  }}
              >
              <TextField
                  fullWidth
                  multiline
                  rows={2}
                  placeholder="Pause. Muse — and write..."
                  value={newPost} 
                  //value={newComment}
                  //onChange={e => setNewComment(e.target.value)}
                  onChange={(e) => setNewPost(e.target.value)} 
              />
              <Button variant="outlined" sx={{ mt: 1 }} onClick={handlePost}>
                  Submit Post
              </Button>
              </Box>

            {/** render each post in topic */}
            {posts.map((post, idx) => {
            const isLast = idx === posts.length - 1;

            return (
                <Box
                    key={post._id} 
                    ref={isLast ? lastPostRef : null}
                    onClick={() => history.push(`/post/${post._id}/comments`)}
                    border="1px solid #ccc" // light border
                    borderRadius="6px" // rounded corners
                    p={2} // padding inside
                    my={2} // margin top and bottom
                    //position="relative"
                    sx={{ 
                        position: "relative", 
                        maxWidth: 900, // limit width 
                        mx: "auto", // center horizontally
                        my: 2, // vertical spacing between each post
                        "&:hover": {
                            backgroundColor: "#f9f9f9"
                        }
                    }}
                >
                    {/* Video Call Button in Top-Right */}
                    {/*<Box position="absolute" top={8} right={8}>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => joinVideoCall(post._id)}
                        >
                            Join Video Call
                        </Button>
                    </Box>*/}

                    {/*
                    <Typography variant="subtitle2">@{post.author.username}</Typography>

                    <Typography>{post.title}</Typography>

                    <Typography>{post.content}</Typography>

                    <Typography variant="caption">
                        {new Date(post.created_at).toLocaleString()}
                    </Typography>
                    */}
                    <Box display="flex" alignItems="flex-start" gap={1}>
                        <Avatar
                        src={post.author?.profileImageUrl || '/default-avatar.jpg'}
                        alt={`${post.author?.first_name || ''} ${post.author?.last_name || ''}`}
                        onClick={(e) => visitProfile(e, post.author?._id)}
                           sx={{ 
                            width: 62, 
                            height: 62,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#d9e4f0",
                            }, 
                            }}
                        />
                        <Box>
                        <Typography variant="subtitle1" fontWeight="bold"
                        onClick={(e) => visitProfile(e, post.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                        >
                            {post.author?.first_name && post.author?.last_name
                            ? `${post.author.first_name} ${post.author.last_name}`
                            : 'Unknown Name'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary"
                        onClick={(e) => visitProfile(e, post.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                        >
                            @{post.author?.username || 'unknown'}
                        </Typography>
                        
                        <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                            {post.title}
                        </Typography>

                        {/* Post content */}
                        <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                            {post.content}
                        </Typography>

                        {/* Date */}
                        <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: "block", mt: 0.5 }}
                        >
                            {`${new Date(post.created_at).toLocaleString()}, ${
                                post.commentCount
                            } ${post.commentCount === 1 ? "reply" : "replies"}`}
                        </Typography>

                        </Box>
                    </Box>

                    {/* Upvote Button */}
                    {/*
                    <Box mt={1}>
                        <Button
                            size="small"
                            variant={post.voted ? "contained" : "outlined"}
                            onClick={() => toggleVote(post._id)}
                            >
                            {post.voted ? "Unvote" : "Upvote"}
                        </Button>
                        <Typography variant="body2" component="span" ml={2}>
                            {post.upvotes || 0} upvotes
                        </Typography>
                    </Box>
                    */}
                    {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                        <Button
                        size="small"
                        variant={post.voted ? "contained" : "outlined"}
                        //onClick={() => toggleVote(post._id)}
                        onClick={(e) => {
                                  e.stopPropagation();  
                                  toggleVote(post._id)}
                                }
                        >
                        ▲ {post.voted ? "Unvote" : "Upvote"}
                        </Button>
                        <Typography variant="body2">{post.upvotes} upvotes</Typography>
                    </Box>*/}
                    <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {post.voted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleVote(post._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleVote(post._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{post.upvotes} Power Votes</Typography>
                   </Box>

                    {/* Comment Input */}
                    {/*
                    <Box mt={2}>
                        <TextField
                            placeholder="Add a comment"
                            value={post.newComment || ""}
                            onChange={(e) =>
                                setPosts(prev =>
                                prev.map(p =>
                                    p._id === post._id ? { ...p, newComment: e.target.value } : p
                                )
                                )
                            }
                            fullWidth
                            size="small"
                        />
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => handleAddComment(post._id, post.newComment)}
                            sx={{ mt: 1 }}
                            >
                            Submit Comment
                        </Button>
                    </Box>
                    */}

                    {/** view comments */}
                    {/*<Button
                        variant="outlined"
                        size="small"
                        sx={{ mt: 1 }}
                        onClick={() => history.push(`/post/${post._id}/comments`)}
                        >
                        View Comments
                    </Button>*/}
                </Box>
            );
                })}
        </div>
    );
}

export default AcademicSubjectsPage;